import { useEffect } from 'react';
import TopBar from '../TopBar';
import PaginationGrid from '../../src/PaginationGrid';
import { titleColor, backgroundMainColor } from '../Color';

export default function CncRawData() {
  const logoContent = <span style={{ color: titleColor, fontSize: 40, fontWeight: 'bold' }}>JS</span>;

  useEffect(() => {
    document.title = 'JS MONITORING';
  }, []);
  
  return (
    <div style={{ width: '100%', height: '100vh', backgroundColor: backgroundMainColor}}>
      <TopBar logo={logoContent} title={'CNC RAW DATA'} />

      <div style={{ width: '100%', height: 'calc(100% - 60px)', padding: 20, paddingBottom: 0, boxSizing: 'border-box' }}>
        <PaginationGrid mainHeight={30} longText={true} apiUrl={`${process.env.REACT_APP_API_DOMAIN}js/cnc/raw-data?`} />
      </div>
    </div>
  );
}